import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import { Children, cloneElement } from 'react';
// -*- mode: jsx;-*-

const ENTER = 13;
const SPACE = 32;

/**
     * Wrap children in this element to make them respond to the enter key and
     * space bar as if they were being clicked. Note that you still need to set
     * tabIndex on the child elements.
     *
     * See this.shouldClickOnSpace for more information on differences in how
     * the enter key and space bar should be handled.
     */
export const KeyboardClickable = createReactClass({
    propTypes: {
        children: PropTypes.element,
    },

    isAnchorTag(element) {
        return element.tagName.toLowerCase() === 'a';
    },

    hasButtonRole(element) {
        return element.getAttribute('role') === 'button';
    },

    shouldClickOnSpace(element) {
        // Don't click <a>s on space-bar-press *unless* it has role="button"
        // This is what screenreaders expect; see http://www.last-child.com/keyboard-accessibility-with-the-space-bar/
        return !this.isAnchorTag(element) || this.hasButtonRole(element);
    },

    onKeyPress(event) {
        // keypress has charcode, keydown has keycode
        if (event.charCode === ENTER || (event.charCode === SPACE && this.shouldClickOnSpace(event.currentTarget))) {
            // Originally, we did this:
            // event.currentTarget.click();
            // That won't work in SVG elements, which don't have a click() method. But this works:
            const clickEvent = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window,
            });
            event.currentTarget.dispatchEvent(clickEvent);

            // See https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent
        }
    },

    render() {
        var wrappedChildren = Children.map(this.props.children, (child) => {
            return cloneElement(child, { onKeyPress: this.onKeyPress });
        });

        return <span>{wrappedChildren}</span>;
    },
});
